//@ts-nocheck
import React from "react";
import { Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { textColor } from "../../../utils/commonstyle";
import { useMsal } from "@azure/msal-react";

const SilaVerificationFailed = () => {
  const navigate = useNavigate();
  const { instance } = useMsal();

  const account: any = instance.getActiveAccount();

  return (
    <Box
      sx={{
        maxWidth: { xs: "90%", md: "45%" },
        mx: "auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: { xs: "80vh", md: "65vh" },
        boxShadow: 1,
        bgcolor: "background.paper",
        textAlign: "center",
        p: 4,
        mt: 1,
      }}
      data-testid="identity-verification-container"
    >
      <Typography
        variant="h5"
        component="h5"
        sx={{
          fontWeight: 600,
          fontSize: { xs: "1.25rem", md: "26px" },
          color: "text.primary",
          mb: 2,
        }}
        data-testid="verification-title"
      >
        Service Unavailable
      </Typography>
      <Typography
        variant="body2"
        sx={{
          fontSize: { xs: "0.875rem", md: "1rem" },
          color: textColor.fontColor,
        }}
        data-testid="verification-notification"
      >
        We are currently unable to process your request due to a temporary issue <br/>
        with our third-party service provider. Please try again later <br />
        You can contact our support team at{" "}
        <Typography
          component="span"
          sx={{
            fontSize: { xs: "0.875rem", md: "1rem" },
            color: textColor.primaryColor,
            mx: 0.5,
          }}
          data-testid="email-address"
        >
          <a
            href="mailto:auction.customerservice@xome.com"
            style={{ color: textColor.primaryColor }}
          >
            auction.customerservice@xome.com
          </a>
        </Typography>
      </Typography>
    </Box>
  );
};

export default SilaVerificationFailed;
